import moment from "moment";

export class Inspection {
  id?: number;
  type?: 'IROS' | 'ANALYSIS';
  title?: string;
  restriction?: string;
  startAt?: Date;
  endAt?: Date;
  writeAt?: Date;

  constructor(inspection: Inspection) {
    if (inspection) {
      this.id = inspection.id;
      this.type = inspection.type;
      this.title = inspection.type === 'IROS' ? '인터넷등기소 점검 (일부 서비스 제한) 안내' : '서비스 긴급점검(일부 서비스 제한) 안내'
      this.restriction = inspection.restriction;
      this.startAt = inspection.startAt;
      this.endAt = inspection.endAt;
      this.writeAt = inspection.writeAt;
    }
  }

  getContent() {
    let content;
    if (this.type === 'IROS') {
      content = '인터넷 등기소 정기점검으로 서비스 이용이 제한됩니다.\n'
    } else {
      content = '서비스 긴급점검으로 서비스 이용이 제한됩니다.\n'
    }

    content += '이용에 참고하시기 바랍니다.\n\n' +
      `기간 : ${moment(this.startAt).format('YYYY.MM.DD A HH : mm')} 부터 ${moment(this.endAt).format('YYYY.MM.DD A HH : mm')} \n\n` +
      `제한 서비스 : ${this.restriction}`

    return content;
  }

  isInspectionTime() {
    return moment().isBetween(moment(this.startAt), moment(this.endAt));
  }

  isRestrictedCheckChanges() {
    return this.type === 'IROS' && this.restriction?.includes('등기변동 정보 즉시 확인')
  }

  isRestrictedIssueRegistration() {
    return this.type === 'IROS' && this.restriction?.includes('부동산등기부등본 열람')
  }

  isRestrictedViewReport() {
    return this.type === 'ANALYSIS' && this.restriction?.includes('권리분석 보고서 확인')
  }
}
